var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerSettingsNewOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 22,
    height: 22,
    fill: "#08ccff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#08ccff",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2001",
    "data-name": "Groupe 2001",
    transform: "translate(1 0.995)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 1.042,
    height: 2.937,
    transform: "translate(14.479 3.834)",
    fill: "#08ccff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2000",
    "data-name": "Groupe 2000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1999",
    "data-name": "Groupe 1999",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_723",
    "data-name": "Trac\\xE9 723",
    d: "M16.944,4.612l-.2-.17L15.9,5.28l.247.2a1.8,1.8,0,0,1,.675,1.41,1.827,1.827,0,1,1-2.981-1.415l.244-.2-.834-.833-.2.17a3,3,0,1,0,3.888,0",
    fill: "#08ccff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_724",
    "data-name": "Trac\\xE9 724",
    d: "M4.5,14A1.5,1.5,0,1,0,6,15.5,1.5,1.5,0,0,0,4.5,14",
    fill: "#08ccff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_725",
    "data-name": "Trac\\xE9 725",
    d: "M10,15.5A1.5,1.5,0,1,0,11.5,14,1.5,1.5,0,0,0,10,15.5",
    fill: "#08ccff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_726",
    "data-name": "Trac\\xE9 726",
    d: "M15,0A6.979,6.979,0,0,0,9.25,3.02C8.84,3.01,8.43,3,8,3,3.58,3,0,3.5,0,7V17a2.986,2.986,0,0,0,1,2.22V21a1,1,0,0,0,1,1H3a1,1,0,0,0,1-1V20h8v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V19.22A2.986,2.986,0,0,0,16,17V13.92A7,7,0,0,0,15,0M8,5h.29a8.293,8.293,0,0,0-.21.99H2.34C2.89,5.46,4.31,5,8,5M2,7.99H8.08A7.021,7.021,0,0,0,9.26,11H2ZM14,17a.968.968,0,0,1-.34.73l-.29.27H2.63l-.29-.27A.968.968,0,0,1,2,17V13h9.41a6.8,6.8,0,0,0,2.59.92Zm1-5a5,5,0,1,1,5-5,5,5,0,0,1-5,5",
    fill: "#08ccff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSettingsNewOutlined);
export default __webpack_public_path__ + "static/media/PowerSettingsNewOutlined.dbf2eda8005aadb6427b0f0f1b0eb0bf.svg";
export { ForwardRef as ReactComponent };